import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "../../Components/navbar/navbar";
import RoutesPath from "../../Utils/RoutesPath";
import Home from "../Home/home.jsx";
import Footer from "../../Components/footer/footer.jsx";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions.jsx";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy.jsx";
import CancellationPolicy from "../CancellationPolicy/CancellationPolicy.jsx";
import SmoothScroll from "../../Components/Reusable/SmoothScroll.js";
import FAQ from "../FAQ/FAQ.jsx";
import AboutUs from "../AboutUs/AboutUs.jsx";
import ContactUs from "../ContactUs/ContactUs.jsx";
import OurServices from "../OurServices/OurServices.jsx";
import BharatSAT from "../BharatSAT/BharatSAT.jsx";
import JoinAsCoordinator from "../JoinAsCoordinator/JoinAsCoordinator.jsx";
import StudentRegistration from "../StudentRegistration/StudentRegistration.jsx";
import TermsAndConditionsCoordinator from "../TermsAndConditions/CoordinatorTermsAndConditions.jsx";
import BharatSatScholarship from "../BharatSatScholarship/BharatSatScholarship.jsx";
import { useCallback, useContext, useEffect, useRef } from "react";
import Blog from "../Blog/Blog.jsx";
import BlogDetails from "../Blog/BlogDetails.jsx";
import Login from "../../StudentPanel/Auth/Login.jsx"
import ForgotPassword from "../../StudentPanel/Auth/ForgotPassword.jsx";
import ResetPassword from "../../StudentPanel/Auth/ResetPassword.jsx";
import StudentDashboard from "../../StudentPanel/StudentDashboard/StudentDashboard.jsx";
import PackageDetails from "../../StudentPanel/StudentDashboard/PackageDetails.jsx";
import Mocktest from "../../StudentPanel/MockTest/Mocktest.jsx";
import Studymodules from "../../StudentPanel/StudyMaterials/StudyModules.jsx";
import Studytopics from "../../StudentPanel/StudyMaterials/StudyTopics.jsx";
import OTPVerify from "../../StudentPanel/Auth/OtpVerify.jsx";
import OrderHistory from "../../StudentPanel/OrderHistory/OrderHistory.jsx";
import ChangePassword from "../../StudentPanel/ChangePassword/ChangePassword.jsx";
import MyMockTest from "../../StudentPanel/MockTest/MyMockTest.jsx";
import ShowResult from "../../StudentPanel/MockTest/ShowResult.jsx";
import AddToCartPage from "../../StudentPanel/Cart/AddToCart.jsx";
import Checkout from "../../StudentPanel/Cart/Checkout.jsx";
import ViewResults from "../../StudentPanel/MockTest/ViewResults.jsx";
import StudyMaterial from "../../StudentPanel/StudyMaterials/StudyMaterial.jsx";
import { AuthContext } from "../../Context/authContext.js";
import StudentProfile from "../../StudentPanel/StudentfProfile/StudentProfile.jsx";
import CoordinatorDashboard from "../../CoordinatorPanel/CoordinatorDashboard/CoordinatorDashboard.jsx";
import WithdrawlRequest from "../../CoordinatorPanel/WithdrawlRequest/WithdrawlRequest.jsx";
import TransactionHistory from "../../CoordinatorPanel/TransactionHistory/TransactionHistory.jsx";
import CoordinatorChangePassword from "../../CoordinatorPanel/CoordinatorChangePassword/CoordinatorChangePassword.jsx";
import BankDetails from "../../CoordinatorPanel/BankDetails/BankDetails.jsx";
import Profile from "../../CoordinatorPanel/Profle/Profile.jsx";
import CoordinatorLogin from "../../CoordinatorPanel/Auth/CoordinatorLogin.jsx";
import CoordinatorForgotPassword from "../../CoordinatorPanel/Auth/CoordinatorForgotPassword.jsx";
import CoordinatorResetPassword from "../../CoordinatorPanel/Auth/CoordinatorResetPassword.jsx";
import PaidSyllabus from "../../StudentPanel/PaidSyllabus/PaidSyllabus.jsx";
import CoordinatorOtpVarify from "../../CoordinatorPanel/Auth/CoordinatorOtpVarify.jsx";
import BharatSat from "../../StudentPanel/BharatSat/BharatSat.jsx";
import DeleteUser from "../Delete/Delete.jsx";
import BharatSatTest from "../../BharatSatExam/BharatSatMockTest/BharatSatTest.jsx";
import BharatSatExamOtpVerify from "../../BharatSatExam/Auth/BharatSatExamOtpVerify.jsx";
import BharatSatResetPassword from "../../BharatSatExam/Auth/BharatSatExamResetPassword.jsx";
import BharatSatExamForgotPassword from "../../BharatSatExam/Auth/BharatSatExamForgotPassword.jsx";
import BharatSatExamLogin from "../../BharatSatExam/Auth/BharatSatExamLogin.jsx";



const Dashboard = () => {
    const scrollContainerRef = useRef(null);
    const scrollAmount = 60; // Adjust scroll amount for desired scroll speed
    const { isAuthenticated, user } = useContext(AuthContext);
    const { isCoordinatorAuthenticated, coordinator } = useContext(AuthContext);
    const location = useLocation();
    let scrollInterval = null;

    const scroll = (direction) => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                top: direction * scrollAmount,
                behavior: 'smooth', // Smooth scroll behavior
            });
        }
    };

    const startScrolling = (direction) => {
        if (scrollInterval) return; // Prevent multiple intervals
        scroll(direction); // Perform an initial scroll
        scrollInterval = setInterval(() => {
            scroll(direction);
        }, 300); // Adjust interval speed for desired effect
    };

    const stopScrolling = () => {
        clearInterval(scrollInterval);
        scrollInterval = null;
    };

    const handleKeyDown = (event) => {
        if (!scrollInterval) {
            switch (event.key) {
                case 'ArrowUp':
                    startScrolling(-6); // Scroll up
                    break;
                case 'ArrowDown':
                    startScrolling(6); // Scroll down
                    break;
                default:
                    break;
            }
        }
    };

    const handleKeyUp = () => {
        stopScrolling();
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            stopScrolling(); // Ensure scrolling stops when component unmounts
        };
    }, []);
    const authRoutes = [
        RoutesPath.login,
        RoutesPath.forgotPassword,
        RoutesPath.otpVerify,
        RoutesPath.resetPassword,
        RoutesPath.dashboardstudent,
        `${RoutesPath.packagedetails}/*`,
        RoutesPath.studymaterials,
        `${RoutesPath.mocktest}/*`,
        `${RoutesPath.studytopics}/*`,
        `${RoutesPath.studymodules}/*`,
        RoutesPath.orderhistory,
        RoutesPath.changepassword,
        RoutesPath.mymocktest,
        `${RoutesPath.showresult}/*`,
        RoutesPath.addtocart,
        RoutesPath.checkout,
        `${RoutesPath.viewresult}/*`,
        RoutesPath.studentprofile,
        RoutesPath.dashboardcoordinator,
        RoutesPath.withdrawlrequest,
        RoutesPath.transactionhistory,
        RoutesPath.coordinatorchangepassword,
        RoutesPath.updatebankdetails,
        RoutesPath.profile,
        RoutesPath.cologin,
        RoutesPath.coforgotPassword,
        RoutesPath.coresetPassword,
        RoutesPath.paidsyllabus,
        RoutesPath.coordinatorotpVerify,

        //BharatSat-Mock-Test
        RoutesPath.bharatsat,
        RoutesPath.bharatsatexamlogin,
        RoutesPath.bharatsatexamforgotpassword,
        RoutesPath.bharatsatexamresetpassword,
        RoutesPath.bharatsatexamotpverify,
        `${RoutesPath.bharatSatTest}/*`,
        "/bharatsatexam/*"


    ];

    // const isAuthRoute = authRoutes.includes(location.pathname);
    const isAuthRoute = authRoutes.some(route => new RegExp(`^${route.replace('*', '.*')}$`).test(location.pathname));
    //  || /^\/bharatsatexam\/\d+$/.test(location.pathname);

    return (
        <div className="d-flex flex-column parentDivBody" >
            {!isAuthRoute && <Navbar />}
            <div id="ScrollContainer" ref={scrollContainerRef} className="d-flex flex-column h-100 overflow-auto">
                <SmoothScroll>
                    <Routes>
                        <Route path={RoutesPath.home} element={<Home />} />
                        <Route path={RoutesPath.faq} element={<FAQ />} />
                        <Route path={RoutesPath.aboutUs} element={<AboutUs />} />
                        <Route path={RoutesPath.deleteuser} element={<DeleteUser />} />
                        <Route path={RoutesPath.contactUs} element={<ContactUs />} />
                        <Route path={RoutesPath.joinAsCoordinator} element={<JoinAsCoordinator />} />
                        <Route path={RoutesPath.bharatSAT} element={<BharatSAT />} />
                        <Route path={RoutesPath.bharatSatScholarship} element={<BharatSatScholarship />} />
                        <Route path={RoutesPath.termsAndConditions} element={<TermsAndConditions />} />
                        <Route path={RoutesPath.termsAndConditionsCoordinator} element={<TermsAndConditionsCoordinator />} />
                        <Route path={RoutesPath.cancellationPolicy} element={<CancellationPolicy />} />
                        <Route path={RoutesPath.privacyPolicy} element={<PrivacyPolicy />} />
                        <Route path={RoutesPath.services} element={<OurServices />} />
                        <Route path={RoutesPath.studentRegistration} element={<StudentRegistration />} />
                        <Route path={RoutesPath.blog} element={<Blog />} />
                        <Route path={`${RoutesPath.blogdetails}/:blogId`} element={<BlogDetails />} />

                        {/* Student Dashboard with nested routes */}
                        <Route path={RoutesPath.login} element={< Login />} />
                        <Route path={RoutesPath.forgotPassword} element={<ForgotPassword />} />
                        <Route path={RoutesPath.otpVerify} element={<OTPVerify />} />
                        <Route path={RoutesPath.resetPassword} element={<ResetPassword />} />

                        <Route path={RoutesPath.cologin} element={< CoordinatorLogin />} />
                        <Route path={RoutesPath.coforgotPassword} element={<CoordinatorForgotPassword />} />
                        <Route path={RoutesPath.coresetPassword} element={<CoordinatorResetPassword />} />
                        <Route path={RoutesPath.coordinatorotpVerify} element={<CoordinatorOtpVarify />} />
                        {/* BharatSatExamMockTest */}
                        {/* <Route path={RoutesPath.bharatsatexamlogin} element={<BharatSatExamLogin />} /> */}
                        <Route path="/bharatsatexam/:encodedId" element={<BharatSatExamLogin />} />
                        <Route path={RoutesPath.bharatsatexamforgotpassword} element={<BharatSatExamForgotPassword />} />
                        <Route path={RoutesPath.bharatsatexamresetpassword} element={<BharatSatResetPassword />} />
                        <Route path={RoutesPath.bharatsatexamotpverify} element={<BharatSatExamOtpVerify />} />
                        <Route path={`${RoutesPath.bharatSatTest}/:encodedId`} element={<BharatSatTest />} />


                        {/* Coordinator Protected Routes */}
                        {isCoordinatorAuthenticated && (
                            <>
                                <Route path={RoutesPath.dashboardcoordinator} element={<CoordinatorDashboard />} />
                                <Route path={RoutesPath.withdrawlrequest} element={<WithdrawlRequest />} />
                                <Route path={RoutesPath.transactionhistory} element={<TransactionHistory />} />
                                <Route path={RoutesPath.coordinatorchangepassword} element={<CoordinatorChangePassword />} />
                                <Route path={RoutesPath.updatebankdetails} element={<BankDetails />} />
                                <Route path={RoutesPath.profile} element={<Profile />} />
                            </>
                        )}

                        {/* Student Protected Routes */}
                        {isAuthenticated && (
                            <>
                                <Route path={RoutesPath.dashboardstudent} element={<StudentDashboard />} />
                                {/* <Route path={RoutesPath.studymaterials} element={<StudyMaterial />} /> */}
                                <Route path={`${RoutesPath.packagedetails}/:packageId`} element={<PackageDetails />} />
                                <Route path={`${RoutesPath.mocktest}/:mockTest_id/:package_id`} element={<Mocktest />} />
                                <Route path={RoutesPath.mymocktest} element={<MyMockTest />} />
                                <Route path={`${RoutesPath.studymodules}/:subject_id/:medium`} element={<Studymodules />} />
                                <Route path={`${RoutesPath.studytopics}/:module_id`} element={<Studytopics />} />
                                <Route path={RoutesPath.orderhistory} element={<OrderHistory />} />
                                <Route path={RoutesPath.changepassword} element={<ChangePassword />} />
                                <Route path={RoutesPath.addtocart} element={<AddToCartPage />} />
                                <Route path={`${RoutesPath.showresult}/:mockTest_id/:order_id`} element={<ShowResult />} />
                                <Route path={RoutesPath.checkout} element={<Checkout />} />
                                <Route path={`${RoutesPath.viewresult}/:mockTest_id/:mockTestSubmissions_id`} element={<ViewResults />} />
                                <Route path={RoutesPath.paidsyllabus} element={<PaidSyllabus />} />
                                <Route path={RoutesPath.studentprofile} element={<StudentProfile />} />
                                <Route path={RoutesPath.bharatsat} element={<BharatSat />} />
                                {user?.shouldShowBharatSATTab == true && <Route path={RoutesPath.bharatsat} element={<BharatSat />} />}



                            </>
                        )}
                        {/* Redirect to home for all other routes */}
                        <Route path="*" element={<Navigate to={RoutesPath.home} />} />
                    </Routes>

                </SmoothScroll>
                {!isAuthRoute && <Footer />}
            </div>
        </div >
    );
};

export default Dashboard;
